import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
// import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Breadcrumb, Card, Upload, Button, Icon, message } from 'antd';
import { Product } from '../../../models';
import PageHeaderLayout from '../../../layouts/PageHeaderLayout';
import styles from './index.less';

class ExcelForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      // file: '',
      // uploading: false,
    };
  }

  options = {
    name: 'excel',
    action: '/rest/store_product/import',
    accept: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    headers: {
      // authorization: 'authorization-text',
    },
    onChange: (info) => {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} амжилттай хуулагдлаа`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} хуулалт амжилтгүй`);
      }
    },
  }

  render() {
    const breadcrumb = (
      <div className={styles.pageTop}>
        <Breadcrumb className={styles.Topbread}>
          <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/products">Бараа</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Excel file хуулах </Breadcrumb.Item>
        </Breadcrumb>
      </div>);

    return (
      <PageHeaderLayout
        content={breadcrumb}
      >
        <Card bordered bodyStyle={{ display: 'flex' }}>
          <Upload {...this.options} style={{ width: 400 }}>
            <Button>
              <Icon type="upload" /> Excel file хуулах
            </Button>
          </Upload>
        </Card>
      </PageHeaderLayout>
    );
  }
}

export default connect(() => ({}), {
  excelUpload: Product.excel,
})(ExcelForm);



// WEBPACK FOOTER //
// ./src/containers/Products/Excel/index.js